    // Reveal JS
    function reveal() {
            var reveals = document.querySelectorAll(".reveal");
            for (var i = 0; i < reveals.length; i++) {
                var windowHeight = window.innerHeight;
                var elementTop = reveals[i].getBoundingClientRect().top;
                var elementVisible = 150;
                if (elementTop < windowHeight - elementVisible) {
                    reveals[i].classList.add("active");
                } else {
                    reveals[i].classList.remove("active");
                }
            }
        }

        window.addEventListener("scroll", reveal);
        reveal();

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product__info-container').forEach(function (container) {
    Array.from(container.children)
      .filter(child => child.classList.contains('icon_text_block'))
      .forEach(function (el) {
        const prev = el.previousElementSibling;
        if (prev && prev.classList.contains('icon_with_text_wrapper')) {
          prev.appendChild(el);
        } else {
          const wrapper = document.createElement('div');
          wrapper.className = 'icon_with_text_wrapper';

          container.insertBefore(wrapper, el);
          wrapper.appendChild(el);
        }
      });
  });
});